<template>
    <div class="container">
      <div class="row text-center d-flex justify-content-between my-5 pb-5 px-3 border-bottom">
        <div class="col-4" >
          <a class="btn btn-outline-secondary btn-lg btn-block bg-dark d-block"  style="color:pink" href="https://www.instagram.com/bernard.fievre/" target="_blank">            
              <v-icon size="24px" style="color:pink;">mdi-instagram</v-icon>
              <span id="insta">&nbsp;&nbsp;&nbsp;&nbsp;Retrouvez-nous sur instagram</span>
          </a>
        </div>
        <div class="col-8 bg-dark">
          <div class="fb-page" data-href="https://www.facebook.com/bernard.fievre.artiste.peintre/" data-tabs="timeline, messages" data-width="500" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/bernard.fievre.artiste.peintre/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/bernard.fievre.artiste.peintre/">Bernard Fievre artiste-peintre</a></blockquote></div>
        </div>
      </div>
    </div>
</template>

<script>
import Vuetify from 'vuetify';

export default {
  name: 'Reseaux',
  vuetify: new Vuetify(),
  data:() =>{
    return{
    }
  },
  created: function(){
    if(localStorage.getItem('test')!='true'){
      localStorage.setItem('test', 'true');
      window.location.reload();
    }  
  },
  destroyed: function(){
    localStorage.removeItem('test');
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700');

@media (max-width: 992px) {
    #insta {
      display: block;
    }
  }
@media (max-width: 768px) {
  #insta {
    display: none;
  }
}
@media (max-width: 576px) {
  #insta {
    display: none;
  }
}

</style>